module.exports = __webpack_public_path__ + "static/media/trash.aff71bea.svg";